
import {
    computed,
    defineComponent,
    onMounted,
    ref,
    toRefs,
    reactive,
} from 'vue'
import ossUpload from '@/common/functions/ossUpload'
import { modeOptions } from '../config'
import AddType from './AddType.vue'
import { getTypeList, addApp, pkgList } from '../request'
import { message } from 'ant-design-vue'
export default defineComponent({
    components: {
        AddType,
        VNodes: (_, { attrs }) => {
            return attrs.vnodes
        },
    },
    props: {
        type: {
            type: String,
            default: 'add',
        },
        detail: {
            type: Object,
            default: null,
        },
    },
    emits: ['close', 'success'],
    setup(props, { emit }) {
        const formRef = ref()
        const { type, detail } = toRefs(props)
        const visible = ref(true)
        const title = computed(() =>
            type.value === 'add' ? '新增应用' : '编辑应用'
        )
        const afterClose = () => {
            emit('close')
        }
        // 获取功能包，排除基础功能包
        const packageList = ref<any>([])
        const getPackages = async () => {
            try {
                const params = {}
                const { data } = await pkgList(params)
                packageList.value = data.filter((item: any) => item.isAppPkg)
                packageList.value = packageList.value.map((item: any) => {
                    return {
                        value: item.id,
                        label: item.name,
                        enable: item.enableSelect === 1,
                    }
                })
            } catch (error) {
                console.log(error)
            }
        }
        const form = reactive({
            name: '',
            code: '',
            icon: '',
            desc: '',
            typeId: null,
            mode: '',
        })
        const rules = {
            name: [
                {
                    required: true,
                    message: '请输入应用名称',
                },
            ],
            code: [
                {
                    required: true,
                    message: '请输入应用Code',
                },
            ],
            icon: [
                {
                    trigger: 'change',
                    required: true,
                    message: '请输入应用LOGO',
                },
            ],
            typeId: [
                {
                    required: true,
                    message: '请选择应用分类',
                },
            ],
            mode: [
                {
                    required: true,
                    message: '请选择开通类型',
                },
            ],
            pkgId: [
                {
                    required: true,
                    message: '请选择应用功能包',
                },
            ],
        }
        const loading = ref(false)
        async function customUploadRequest(param) {
            let res: any = await ossUpload(param)
            let data = res.data
            loading.value = false
            form.icon = data.url
        }
        // 添加应用分类
        const typeVisible = ref(false)
        const addItem = () => {
            typeVisible.value = true
        }
        const typeList = ref([])
        // 获取应用分类list
        const fetchAppTypeList = async () => {
            try {
                const params = {}
                const { data } = await getTypeList(params)
                typeList.value = data
            } catch (error) {
                console.log(error)
            }
        }
        const handleSuccess = () => {
            fetchAppTypeList()
        }
        const handleOk = () => {
            try {
                formRef.value.validate().then(async () => {
                    const params = {
                        ...form,
                    }
                    await addApp(params)
                    message.success('新增应用成功')
                    afterClose()
                    emit('success')
                })
            } catch (error) {
                console.log(error)
            }
        }
        function handleChange(info) {
            if (info.file.status === 'uploading') {
                loading.value = true
                return
            }
        }
        onMounted(() => {
            if (type.value === 'mod') {
                // 获取详情
                Object.assign(form, detail.value)
            }
            fetchAppTypeList()
            getPackages()
        })
        return {
            visible,
            title,
            afterClose,
            form,
            rules,
            customUploadRequest,
            modeOptions,
            packageList,
            typeVisible,
            handleOk,
            addItem,
            typeList,
            handleSuccess,
            formRef,
            handleChange,
            loading,
        }
    },
})
